import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {VisualSizesEnum} from '../../../../../libs/shared/ui/src/styles/commonStyles';
import {useClipboard} from '../../../../helpers/hooks/clipboardHookHelpers';
import {isTeamNamespace} from '../../../../helpers/models/namespaceHelpers';
import {ChannelEmailThreadingModesEnum} from '../../../../models/api/channelCommonTypes';
import {ChannelSmtpModel} from '../../../../models/api/channelModel';
import {SettingsInboxesUrl} from '../../../../models/url/settingsUrlModel';
import {StyledSettingsFormField, StyledSettingsFormTextBox} from '../../../common/settingsWrapper';
import {
  ChannelAutoAssignField,
  ChannelReplyControlField,
  ChannelUndoSendTimingField,
  SettingsCommonChannelFieldProps,
} from '../settingsCommonChannelFields';
import {SettingsAddressField} from './settingsAddressField';
import {SettingsAutoBccField} from './settingsAutoBccField';
import {SettingsCustomSmtpField} from './settingsCustomSmtpField';
import {SettingsSpfDkimField} from './settingsSpfDkimField';
import {SettingsThreadField} from './settingsThreadingField';
import {SettingsTrackingField} from './settingsTrackingField';

/*
 * Props.
 */

interface SettingsSmtpFieldsProps extends SettingsCommonChannelFieldProps<ChannelSmtpModel> {
  url: SettingsInboxesUrl;
}

/*
 * Style.
 */

/*
 * Component.
 */

export const SettingsSmtpFields: FC<SettingsSmtpFieldsProps> = (props) => {
  const {edited, setDirty, onChange, onPreferencesChange} = props;
  const {copy} = useClipboard();
  const isSharedChannel = isTeamNamespace(props.edited.namespace);

  return (
    <div>
      <SettingsAddressField
        edited={edited}
        setDirty={setDirty}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
      />
      <StyledSettingsFormField>
        <StyledSettingsFormTextBox
          $width={300}
          size={VisualSizesEnum.MEDIUM}
          onCopy={() => {
            copy(edited.address);
          }}
          value={edited.address}
          label={<Trans id="settingssmtp-forward-label">Forward</Trans>}
          message={<Trans id="settingssmtp-forward-message">Forward your emails to this address.</Trans>}
        />
      </StyledSettingsFormField>
      <ChannelUndoSendTimingField
        edited={edited}
        setDirty={setDirty}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
      />
      {isSharedChannel && (
        <ChannelReplyControlField
          edited={edited}
          onChange={onChange}
          onPreferencesChange={onPreferencesChange}
          setDirty={setDirty}
        />
      )}
      <ChannelAutoAssignField
        edited={edited}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
        setDirty={setDirty}
      />
      <SettingsTrackingField
        edited={edited}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
        setDirty={setDirty}
      />
      <SettingsAutoBccField
        edited={edited}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
        setDirty={setDirty}
      />
      <SettingsSpfDkimField
        edited={edited}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
        setDirty={setDirty}
      />
      <SettingsCustomSmtpField
        edited={edited}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
        setDirty={setDirty}
      />
      <SettingsThreadField
        edited={edited}
        onChange={onChange}
        onPreferencesChange={onPreferencesChange}
        setDirty={setDirty}
        possibleValues={[
          ChannelEmailThreadingModesEnum.REGULAR,
          ChannelEmailThreadingModesEnum.SUBJECT,
          ChannelEmailThreadingModesEnum.DISABLED,
        ]}
      />
    </div>
  );
};
